import React from "react";
import _ from "lodash";
import {CommonSubmitButton, isEmpty, LoaderType, RenderForm, showNotification, SwitchLoader} from "../../../common";
import { useHistory } from "react-router-dom";
import {NotificationFormData, SystemNotificationModel} from "../../../model";
import {IState} from "../Data";
import { SystemNotificationService } from "../../../services/SystemNotificationService";
import { asyncSelectSearchable } from "../../../helpers/UserHelper";


export const NotificationForm = (props: IState) => {
  let history = useHistory();
  const [form, setForm] = React.useState({} as SystemNotificationModel);
  const [data, setData] = React.useState({} as any);
  const [occurDays, setOccurDays] = React.useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLElement>) => {
    const target : any = event.target;
    const {name, value} = target;
    setForm({...form, [name]:  value})
  }
  const handleOccurDays = (event: React.ChangeEvent<HTMLSelectElement>) => {
  const { name, value } = event.target;
  if (Number(value) === 14 || Number(value) === 19) {
    setOccurDays(true);
  } else {
    setOccurDays(false);
  }
};

  const handleSelect2 = field => (inputValue) => {
    setForm({...form, [field]:  inputValue})
  }

  React.useEffect(() => {
    const {data} = props;
   if(data){

      if(data.system_event_id === 14){
        setOccurDays(true);
      }
      data["email_templates"] =  defaultEmailtemplates(data.email_templates) ;
      setForm(data)
    }
   
  },[props.data])
  function getRoleOptions() {
    return [
      { id: 3, name: "Coach" },
      { id: 4, name: "Player" }
    ];
  }
  React.useEffect(() => {
    async function init() {
      const dataForForm: NotificationFormData = await SystemNotificationService.dataForNotificationForm();
      setData(dataForForm)
    }
    init()
  },[])

  const loadEmailTemplates = () => (inputValue, callback) => {    
    callback( asyncSelectSearchable(_.get(data, "email_templates", []))(inputValue) );
  }

  function defaultEmailtemplates(email_templates) {
    let templates = [];
    const oldMembers = email_templates;
    if(oldMembers){
      // @ts-ignore
      oldMembers.map(item => templates.push({value: item.id, id: item.id, label: item.name}))
    }
    return templates;
  }
  function getFilteredEvents(selectedRoleId) {
    return (_.get(data, "events", []) || []).filter(event => {
      let roles = [];

      // If it's already an array, use it; otherwise, parse it
      if (Array.isArray(event.notification_for)) {
        roles = event.notification_for;
      } else if (typeof event.notification_for === "string") {
        try {
          roles = JSON.parse(event.notification_for);
        } catch (e) {
          roles = []; // invalid JSON fallback
        }
      }

      return roles.map(String).includes(String(selectedRoleId));
    });
  }
  const FormInputs = [
    {
      "name" : "title",
      "value" : _.get(form, "title", ""),
      "onChange": handleChange,
      "required": true,
      "placeholder": "Enter notification title",
      "label": "Notification Title",
    },
    {
      "name": "role_id",
      "value": _.get(form, "role_id", ""),
      "onChange": handleChange,
      "required": true,
      "type": "select1",
      "placeholder": "Select Role",
      "label": "Select Role",
     "options": getRoleOptions()
    },
    {
      "name" : "system_event_id",
      "value" : _.get(form, "system_event_id", ""),
      "onChange": (e) => {
          handleChange(e);       
          handleOccurDays(e);    
        },
      "required": true,
      "type": "select",
      "placeholder": "Select Event",
      "label": "Event",
      "options": getFilteredEvents(_.get(form, "role_id", ""))
    },
    {
      "name" : "occur_days",
      "value" : _.get(form, "occur_days", ""),
      "onChange": handleChange,
      "required": occurDays,
      "placeholder": "Enter occur days",
      "label": "Occur days",
      "show": occurDays,
    },
    {
      "name" : "recurrence",
      "value" : _.get(form, "recurrence", ""),
      "onChange": handleChange,
      "required": true,
      "type": "select",
      "placeholder": "Select recurrence",
      "label": "Recurrence",
      "options" : _.get(data, "recurrence", [])
    },
    {
      "name" : "email_templates",
      "value" : _.get(form, "email_templates", []),
      "onChange": handleSelect2("email_templates"),
      "required": true,
      "type": "select2",
      "placeholder": "Select Email Template",
      "label": "Email Template",
      "isMulti": true,
      "loadOptions" : loadEmailTemplates(),
      "defaultOptions" : _.get(data, "email_templates", [])
    },

  ];

  function isDisable() {
    return FormInputs.reduce((acc, val) => acc ? acc : isEmpty(val.value) && val.required, false);
  }

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    SwitchLoader(LoaderType.BUTTON);

    const payload = {
      ...form,
      email_templates: form.email_templates.map((item) => item.id)
    }
    if(props.id){
      SystemNotificationService.update(payload, props.id).then((message) => {
        showNotification("success", message);
        history.push(`/settings/system-notifications`)
      }).catch(() => {});
    } else {
      SystemNotificationService.store(payload).then((message) => {
        showNotification("success", message);
        history.push(`/settings/system-notifications`)
      }).catch(() => {});
    }
  }

    return(
      <React.Fragment>
        <form className="kt-form" id={'system_notification_form'} onSubmit={handleSubmit}>
          <div className="kt-portlet__body">
            <div className={'row'}>
              <RenderForm items={FormInputs}/>
            </div>
          </div>
          <CommonSubmitButton disabled={isDisable()}/>
        </form>
      </React.Fragment>
      )
}